import {useMutation} from 'react-query';
import postActivePromotion from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IUsePostActivePromotionProps {
  onSuccess?: () => void;
}
const usePostActivePromotion = ({onSuccess}: IUsePostActivePromotionProps) => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IActivePromotionPayload) => {
      return postActivePromotion(payload);
    },
    onSuccess: () => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {mutate, isLoading};
};

export default usePostActivePromotion;
